import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { BackendApi } from "../api/api.ts";
import { User } from "../api/accessControl/User.ts";
import { Client } from "../pages/app/partner/Client.ts";
import { isAbortError } from "../lib/abortError.ts";

export function usePartnerClients(currentUser: User): Client[] {
    const [clients, setClients] = useState<Client[]>([]);

    useEffect(() => {
        const controller = new AbortController();

        async function load() {
            try {
                const api = new BackendApi(currentUser.getToken()).withAbortSignal(controller.signal);
                const response = await api.Partner__myClients();

                setClients(response.businesses as Client[]);
            } catch (error) {
                if (isAbortError(error)) {
                    return;
                }
                Sentry.captureException(error);
            }
        }

        void load();

        return () => controller.abort();
    }, [currentUser]);

    return clients;
}
